import { makeAxiosRequest } from 'utils/apiMethods';

export default {
  getCompanyOnboarding: makeAxiosRequest('/onboarding/{`id`}', { method: 'get' }, true),
  updateCompanyOnboarding: makeAxiosRequest('/onboarding/{`id`}', { method: 'post' }, true),
};
